/* eslint-disable no-duplicate-case */
/* eslint-disable import/no-anonymous-default-export */

import LeadsActionTypes from "./leads.types";
import { docodeHexResponse } from "../../_common/common.utils";

const INITIAL_STATE = {
  addStatusDetailsResponse: null,
  addLeadsDetailsResponse: null,
  updateLeadsDetailsResponse: null,
  updateStatusDetailsResponse: null,
  getLeadsListResponse: null,
  getLeadsListArr: [],
  fetchLeadsDetailsResponse: null,
  fetchLeadsDetailsArr: [],
  deleteLeadsDetailsResponse: null,
  geteStatusListResponse: null,
  getStatusListArr: [],
  getLeadsourceDropdownListResponse: null,
  getLeadsourceDropdownListArr: [],
  searchPreleadListResponse: null,

  searchPreleadListArr: [],
  fetchDocumentListResponse: null,
  addDocumentDetailsResponse: null,
  fetchDocumentListArr: [],
  getLeadAppliedLogListDetailsArr: [],
  getLeadAppliedLogListDetailsResponse: null,
  getSaleAppliedLogListDetailsArr: [],
  getSaleAppliedLogListDetailsResponse: null,
  updateLeadsDocDetailsResponse: null,
  getLeadsDocListResponse: null,
  getLeadsDocListArr: [],
  fetchLeadsDocDetailsResponse: null,
  deleteLeadsDocDetailsResponse: null,
  updateloanAppliedDetailsResponse: null,
  createLeadsDocDetailsResponse: null,
  fetchLeadsDocDetailsArr: [],
  getLeadApplidResponse: null,
  isApplied: null,
  fetchSicDetailsArr: [],
  fetchSicDetailsResponse: null,
  deleteLenderAppliedDetailsResponse: null,
  searchDashboardLeadsResponse: null,
  searchDashboardLeadsArr: [],
  deleteDashboardLeadsResponse: null,
  exportDashboardLeadsResponse: null,
  deleteLenderDocDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /** ***************** ADD STATUS DETAILS START *********************** */
    case LeadsActionTypes.ADD_STATUS_DETAILS_START:
      return { ...state, isLoading: true, error: null };

    case LeadsActionTypes.ADD_STATUS_DETAILS_SUCCESS:
      return {
        ...state,
        addStatusDetailsResponse: action.payload,
        isLoading: false,
      };

    case LeadsActionTypes.ADD_STATUS_DETAILS_FAILURE:
      return {
        ...state,
        addStatusDetailsResponse: action.payload,
        isLoading: false,
        error: action.payload,
      };

    case LeadsActionTypes.ADD_STATUS_DETAILS_RESPONSE_CHANGED:
      return { ...state, addStatusDetailsResponse: null };
    /** ***************** ADD STATUS DETAILS END *********************** */

    /** ***************** ADD Leads DETAILS START *********************** */
    case LeadsActionTypes.ADD_LEADS_DETAILS_SUCCESS:
      return { ...state, addLeadsDetailsResponse: action.payload };

    case LeadsActionTypes.ADD_LEADS_DETAILS_FAILURE:
      return { ...state, addLeadsDetailsResponse: action.payload };

    case LeadsActionTypes.ADD_LEADS_DETAILS_RESPONSE_CHANGED:
      return { ...state, addLeadsDetailsResponse: null };
    /** ***************** ADD Leads DETAILS END *********************** */

    /** ***************** UPDATE Leads DETAILS START *********************** */
    case LeadsActionTypes.UPDATE_LEADS_DETAILS_SUCCESS:
      return { ...state, updateLeadsDetailsResponse: action.payload };

    case LeadsActionTypes.UPDATE_LEADS_DETAILS_FAILURE:
      return { ...state, updateLeadsDetailsResponse: action.payload };

    case LeadsActionTypes.UPDATE_LEADS_DETAILS_RESPONSE_CHANGED:
      return { ...state, updateLeadsDetailsResponse: null };
    /** ***************** UPDATE Leads DETAILS END *********************** */

    /** ***************** GET Leads DETAILS START *********************** */
    case LeadsActionTypes.GET_LEADS_LIST_SUCCESS:
      return {
        ...state,
        getLeadsListResponse: action.payload,
        getLeadsListArr: docodeHexResponse(
          action.payload,
          "GetAllLeadsPainatioinKey",
        ),
      };

    case LeadsActionTypes.GET_LEADS_LIST_FAILURE:
      return {
        ...state,
        getLeadsListResponse: action.payload,
        getLeadsListArr: [],
      };

    case LeadsActionTypes.GET_LEADS_LIST_RESPONSE_CHANGED:
      return { ...state, getLeadsListResponse: null };
    /** ***************** GET Leads DETAILS END *********************** */

    /** ***************** FETCH Leads DETAILS START *********************** */
    case LeadsActionTypes.FETCH_LEADS_DETAILS_SUCCESS:
      return {
        ...state,
        fetchLeadsDetailsResponse: action.payload,
        fetchLeadsDetailsArr: docodeHexResponse(
          action.payload,
          "FetchLeadsKey",
        ),
      };

    case LeadsActionTypes.FETCH_LEADS_DETAILS_FAILURE:
      return { ...state, fetchLeadsDetailsResponse: action.payload };

    case LeadsActionTypes.FETCH_LEADS_DETAILS_RESPONSE_CHANGED:
      return {
        ...state,
        fetchLeadsDetailsResponse: null,
      };
    /** ***************** FETCH Leads DETAILS END *********************** */

    /** ***************** DELETE Leads DETAILS START *********************** */
    case LeadsActionTypes.DELETE_LEADS_DETAILS_SUCCESS:
      return { ...state, deleteLeadsDetailsResponse: action.payload };

    case LeadsActionTypes.DELETE_LEADS_DETAILS_FAILURE:
      return { ...state, deleteLeadsDetailsResponse: action.payload };

    case LeadsActionTypes.DELETE_LEADS_DETAILS_RESPONSE_CHANGED:
      return { ...state, deleteLeadsDetailsResponse: null };
    /** ***************** DELETE Leads DETAILS END *********************** */

    /** ***************** GET STATUS DETAILS LIST START *********************** */
    case LeadsActionTypes.STATUS_LIST_DETAILS_SUCCESS:
      return {
        ...state,
        geteStatusListResponse: action.payload,
        getStatusListArr: docodeHexResponse(
          action.payload,
          "GetAllLeadsStatusListKey",
        ),
      };

    case LeadsActionTypes.STATUS_LIST_DETAILS_FAILURE:
      return { ...state, geteStatusListResponse: action.payload };

    case LeadsActionTypes.STATUS_LIST_DETAILS_RESPONSE_CHANGED:
      return { ...state, geteStatusListResponse: null };
    /** ***************** GETSTATUS DETAILS LIST  END *********************** */

    /** ***************** GET PRODUCT DETAILS LIST START *********************** */
    case LeadsActionTypes.GET_PRODUCT_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        getProductDropdownListResponse: action.payload,
        getProductDropdownListArr: docodeHexResponse(
          action.payload,
          "GetAllProductDropdownListKey",
        ),
      };

    case LeadsActionTypes.GET_PRODUCT_DROPDOWN_LIST_FAILURE:
      return { ...state, getProductDropdownListResponse: action.payload };

    case LeadsActionTypes.GET_PRODUCT_DROPDOWN_LIST_RESPONSE_CHANGED:
      return { ...state, getProductDropdownListResponse: null };

    /** ***************** GET PRODUCT DETAILS LIST  END *********************** */

    /** ***************** GET PRODUCT DETAILS LIST START *********************** */
    case LeadsActionTypes.GET_LEADSOURCE_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        getLeadsourceDropdownListResponse: action.payload,
        getLeadsourceDropdownListArr: docodeHexResponse(
          action.payload,
          "FetchAllLeadsSourceKey",
        ),
      };

    case LeadsActionTypes.GET_LEADSOURCE_DROPDOWN_LIST_FAILURE:
      return { ...state, getLeadsourceDropdownListResponse: action.payload };

    case LeadsActionTypes.GET_LEADSOURCE_DROPDOWN_LIST_RESPONSE_CHANGED:
      return { ...state, getLeadsourceDropdownListResponse: null };

    /** ***************** GET PRODUCT DETAILS LIST  END *********************** */

    /** *****************  SEARCH PRELEAD LIMIT  START *********************** */
    case LeadsActionTypes.SEARCH_PRELEAD_LIMIT_DETAILS_SUCCESS:
      return {
        ...state,
        searchPreleadListResponse: action.payload,
        searchPreleadListArr: docodeHexResponse(
          action.payload,
          "SearchPreLeadMasterKey",
        ),
      };

    case LeadsActionTypes.SEARCH_PRELEAD_LIMIT_DETAILS_FAILURE:
      return { ...state, searchPreleadListResponse: action.payload };

    case LeadsActionTypes.SEARCH_PRELEAD_LIMIT_DETAILS_RESPONSE_CHANGED:
      return { ...state, searchPreleadListResponse: null };

    /** ***************** SEARCH PRELEAD LIMIT   END *********************** */

    /** *****************  FETCH LEADS PRODUCT  START *********************** */
    case LeadsActionTypes.FETCH_DOCUMENT_SUCCESS:
      return {
        ...state,
        fetchDocumentListResponse: action.payload,
        fetchDocumentListArr: docodeHexResponse(
          action.payload,
          "FetchAllDocumentKey",
        ),
      };

    case LeadsActionTypes.FETCH_DOCUMENT_FAILURE:
      return { ...state, fetchDocumentListResponse: action.payload };

    case LeadsActionTypes.FETCH_DOCUMENT_RESPONSE_CHANGED:
      return { ...state, fetchDocumentListResponse: null };

    /** *****************  FETCH LEADS PRODUCT END *********************** */

    /** ***************** ADD DOCUMENT DETAILS START *********************** */
    case LeadsActionTypes.CREATE_DOCUMENT_DETAILS_SUCCESS:
      return { ...state, addDocumentDetailsResponse: action.payload };

    case LeadsActionTypes.CREATE_DOCUMENT_DETAILS_FAILURE:
      return { ...state, addDocumentDetailsResponse: action.payload };

    case LeadsActionTypes.CREATE_DOCUMENT_DETAILS_RESPONSE_CHANGED:
      return { ...state, addDocumentDetailsResponse: null };
    /** ***************** ADD DOCUMENT DETAILS END *********************** */

    /** ***************** FETCH LEAD APPLIED LOG DETAILS START *********************** */
    case LeadsActionTypes.LEAD_APPLIED_LOG_LIST_FETCH_START:
      return {
        ...state,
        getLeadAppliedLogListDetailsResponse: null,
        getLeadAppliedLogListDetailsArr: [],
      };

    case LeadsActionTypes.LEAD_APPLIED_LOG_LIST_CLEAR:
      return {
        ...state,
        getLeadAppliedLogListDetailsResponse: null,
        getLeadAppliedLogListDetailsArr: [],
      };

    case LeadsActionTypes.LEAD_APPLIED_LOG_LIST_FETCH_SUCCESS:
      return {
        ...state,
        getLeadAppliedLogListDetailsResponse: action.payload,
        getLeadAppliedLogListDetailsArr: docodeHexResponse(
          action.payload,
          "getLeadAppliedLogKey",
        ),
      };

    case LeadsActionTypes.LEAD_APPLIED_LOG_LIST_FETCH_FAILURE:
      return {
        ...state,
        getLeadAppliedLogListDetailsResponse: action.payload,
        getLeadAppliedLogListDetailsArr: [],
      };

    case LeadsActionTypes.LEAD_APPLIED_LOG_LIST_FETCH_RESPONSE_CHANGED:
      return {
        ...state,
        getLeadAppliedLogListDetailsResponse: null,
        // getLeadAppliedLogListDetailsArr: [],
      };
    /** ***************** FETCH LEAD APPLIED LOG DETAILS END *********************** */

    /** ***************** FETCH SALE APPLIED LOG DETAILS START *********************** */
    case LeadsActionTypes.SALE_APPLIED_LOG_LIST_FETCH_SUCCESS:
      return {
        ...state,
        getSaleAppliedLogListDetailsResponse: action.payload,
        getSaleAppliedLogListDetailsArr: docodeHexResponse(
          action.payload,
          "getSaleAppliedLogKey",
        ),
      };

    case LeadsActionTypes.SALE_APPLIED_LOG_LIST_FETCH_FAILURE:
      return {
        ...state,
        getSaleAppliedLogListDetailsResponse: action.payload,
      };

    case LeadsActionTypes.SALE_APPLIED_LOG_LIST_FETCH_RESPONSE_CHANGED:
      return {
        ...state,
        getSaleAppliedLogListDetailsResponse: null,
      };
    /** ***************** FETCH SALE APPLIED LOG DETAILS END *********************** */

    /** ***************** UPDATE LEADS_DOC DETAILS START *********************** */
    case LeadsActionTypes.UPDATE_LEADS_DOC_DETAILS_SUCCESS:
      return { ...state, updateLeadsDocDetailsResponse: action.payload };

    case LeadsActionTypes.UPDATE_LEADS_DOC_DETAILS_FAILURE:
      return { ...state, updateLeadsDocDetailsResponse: action.payload };

    case LeadsActionTypes.UPDATE_LEADS_DOC_DETAILS_RESPONSE_CHANGED:
      return { ...state, updateLeadsDocDetailsResponse: null };
    /** ***************** UPDATE LEADS_DOC DETAILS END ***********************----- */

    /** ***************** GET LEADS_DOC DETAILS START *********************** */
    case LeadsActionTypes.GET_LEADS_DOC_LIST_SUCCESS:
      return {
        ...state,
        getLeadsDocListResponse: action.payload,
        getLeadsDocListArr: docodeHexResponse(
          action.payload,
          "GetAllDocumentKey",
        ),
      };
    case LeadsActionTypes.GET_LEADS_DOC_LIST_FAILURE:
      return {
        ...state,
        getLeadsDocListResponse: action.payload,
        getLeadsDocListArr: [],
      };

    case LeadsActionTypes.GET_LEADS_DOC_LIST_RESPONSE_CHANGED:
      return {
        ...state,
        getLeadsDocListResponse: null,
        getLeadsDocListArr: [],
      };
    /** ***************** GET LEADS_DOC DETAILS END *********************** */

    /** ***************** FETCH LEADS_DOC DETAILS START *********************** */
    case LeadsActionTypes.FETCH_LEADS_DOC_DETAILS_SUCCESS:
      return {
        ...state,
        fetchLeadsDocDetailsResponse: action.payload,
        fetchLeadsDocDetailsArr: docodeHexResponse(
          action.payload,
          "GetAllLeadsDocPaginationKey",
        ),
      };
    case LeadsActionTypes.FETCH_LEADS_DOC_DETAILS_FAILURE:
      return {
        ...state,
        fetchLeadsDocDetailsResponse: action.payload,
        fetchLeadsDocDetailsArr: [],
      };

    case LeadsActionTypes.FETCH_LEADS_DOC_DETAILS_RESPONSE_CHANGED:
      return { ...state, fetchLeadsDocDetailsResponse: null };
    /** ***************** FETCH LEADS_DOC DETAILS END *********************** */

    /** ***************** DELETE LEADS_DOC DETAILS START *********************** */
    case LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_SUCCESS:
      return { ...state, deleteLeadsDocDetailsResponse: action.payload };

    case LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_FAILURE:
      return { ...state, deleteLeadsDocDetailsResponse: action.payload };

    case LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_RESPONSE_CHANGED:
      return { ...state, deleteLeadsDocDetailsResponse: null };
    /** ***************** DELETE LEADS_DOC DETAILS END *********************** */

    /** ***************** UPDATE LOAN APPLIED  DETAILS START *********************** */
    case LeadsActionTypes.LOAN_APPLIED_DETAILS_START:
      return {
        ...state,
        getLeadAppliedLogListDetailsArr: [],
      };

    case LeadsActionTypes.LOAN_APPLIED_DETAILS_SUCCESS:
      return { ...state, updateloanAppliedDetailsResponse: action.payload };

    case LeadsActionTypes.LOAN_APPLIED_DETAILS_FAILURE:
      return { ...state, updateloanAppliedDetailsResponse: action.payload };

    case LeadsActionTypes.LOAN_APPLIED_DETAILS_CHANGE:
      return { ...state, updateloanAppliedDetailsResponse: null };
    // /** ***************** UPDATELOAN APPLIED DETAILS END *********************** */

    //     /** *****************  CREATE DOCUMENT DETAILS START *********************** */
    case LeadsActionTypes.CREATE_DOCUMENT_DETAILS_SUCCESS:
      return { ...state, createLeadsDocDetailsResponse: action.payload };

    case LeadsActionTypes.CREATE_DOCUMENT_DETAILS_FAILURE:
      return { ...state, createLeadsDocDetailsResponse: action.payload };

    case LeadsActionTypes.CREATE_DOCUMENT_DETAILS_RESPONSE_CHANGED:
      return { ...state, createLeadsDocDetailsResponse: null };
    // /** ***************** CREATE DOCUMENT DETAILS START END *********************** */

    /** ***************** SEARCH COMPANY DETAILSSTART *********************** */
    case LeadsActionTypes.GET_LEAD_APPLIED_LIST_SUCCESS:
      return {
        ...state,
        getLeadApplidResponse: action.payload,
        isApplied: action.payload,
        getLeadApplidArr: docodeHexResponse(
          action.payload,
          "GetLeadAppliedKey",
        ),
      };
    case LeadsActionTypes.GET_LEAD_APPLIED_LIST_FAILURE:
      return {
        ...state,
        getLeadApplidResponse: action.payload,
        getLeadApplidArr: [],
        isApplied: action.payload,
      };

    case LeadsActionTypes.GET_LEAD_APPLIED_LIST_RESPONSE_CHANGED:
      return { ...state, getLeadApplidResponse: null };
    /** *****************SEARCH COMPANY DETAILS END *********************** */

    /** ***************** GET SIC DETAILS START *********************** */
    case LeadsActionTypes.FETCH_SIC_DETAILS_SUCCESS:
      return {
        ...state,
        fetchSicDetailsResponse: action.payload,
        fetchSicDetailsArr: docodeHexResponse(action.payload, "GetSicKey"),
      };

    case LeadsActionTypes.FETCH_SIC_DETAILS_FAILURE:
      return { ...state, fetchSicDetailsResponse: action.payload };

    case LeadsActionTypes.FETCH_SIC_DETAILS_RESPONSE_CHANGED:
      return {
        ...state,
        fetchSicDetailsResponse: null,
      };
    /** *****************GET SIC DETAILS END *********************** */

    /** ***************** UPDATE STATUS  DETAILS START *********************** */
    case LeadsActionTypes.UPDATE_STATUS_DETAILS_SUCCESS:
      return { ...state, updateStatusDetailsResponse: action.payload };

    case LeadsActionTypes.UPDATE_STATUS_DETAILS_FAILURE:
      return { ...state, updateStatusDetailsResponse: action.payload };

    case LeadsActionTypes.UPDATE_STATUS_DETAILS_RESPONSE_CHANGED:
      return { ...state, updateStatusDetailsResponse: null };
    /** ***************** UPDATE STATUS DETAILS END *********************** */

    /** ***************** DELETE LENDER APPLIED DETAILS START *********************** */
    case LeadsActionTypes.DELETE_LENDER_APPLIED_DETAILS_SUCCESS:
      return { ...state, deleteLenderAppliedDetailsResponse: action.payload };

    case LeadsActionTypes.DELETE_LENDER_APPLIED_DETAILS_FAILURE:
      return { ...state, deleteLenderAppliedDetailsResponse: action.payload };

    case LeadsActionTypes.DELETE_LENDER_APPLIED_DETAILS_RESPONSE_CHANGED:
      return { ...state, deleteLenderAppliedDetailsResponse: null };
    /** ***************** DELETE LENDER APPLIED DETAILS END *********************** */

    /** ***************** SEARCH DASHBOARD LEADS START *********************** */
    case LeadsActionTypes.SEARCH_DASHBOARD_LEADS_SUCCESS:
      return {
        ...state,
        searchDashboardLeadsResponse: action.payload,
        searchDashboardLeadsArr: docodeHexResponse(
          action.payload,
          "SearchDashboardLeadsKey", // User will define this key
        ),
        isLoading: false,
      };

    case LeadsActionTypes.SEARCH_DASHBOARD_LEADS_FAILURE:
      return {
        ...state,
        searchDashboardLeadsResponse: action.payload,
        searchDashboardLeadsArr: [],
        isLoading: false,
      };

    case LeadsActionTypes.SEARCH_DASHBOARD_LEADS_RESPONSE_CHANGED:
      return { ...state, searchDashboardLeadsResponse: null };
    /** ***************** SEARCH DASHBOARD LEADS END *********************** */

    /** ***************** DELETE LENDER APPLIED DETAILS START *********************** */
    case LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_SUCCESS:
      return { ...state, deleteLenderDocDetailsResponse: action.payload };

    case LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_FAILURE:
      return { ...state, deleteLenderDocDetailsResponse: action.payload };

    case LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_RESPONSE_CHANGED:
      return { ...state, deleteLenderDocDetailsResponse: null };
    /** ***************** DELETE LENDER APPLIED DETAILS END *********************** */
    default:
      return state;
  }
};
